export default function showCOInput() {
  $('.form-group--colapsed .func-opener-btn').on('click', function () {
    $(this).hide();
    $('.colapsed-input').show();
  });
}